import { useGetBrandPermissionsConst } from "@entities/brand/lib/hooks/useGetBrandPermissionsConst";
import { AdminUser } from "@shared/lib/types";
import { CircularProgress } from "@shared/ui";
import { Avatar, Divider, Flex, Row } from "antd";

import styles from "../styles.module.scss";

interface Props {
  employee: AdminUser;
}

export function BrandPermissionCard({ employee }: Props) {
  const { brandPermissions, isFetching } = useGetBrandPermissionsConst();

  if (isFetching) {
    return (
      <Row justify={"center"}>
        <CircularProgress />
      </Row>
    );
  }
  if (!(brandPermissions || []).length) return <></>;
  if (!(employee.assignedBrands || []).length) return <></>;

  return (
    <div className={styles.card}>
      <div className={styles.permTitle}>Brands</div>
      <Divider style={{ margin: 0 }} />
      <div className={styles.permContent}>
        {employee.assignedBrands.map((permItem) => (
          <Flex gap={10} align="center" style={{ padding: 10 }}>
            <Avatar src={permItem?.logoUrl} />
            {permItem?.name}
          </Flex>
        ))}
      </div>
    </div>
  );
}
